import { render, staticRenderFns } from "./WallLocationsBlockGeneralSettings.vue?vue&type=template&id=0cbc687a"
import script from "./WallLocationsBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./WallLocationsBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports